import { cn } from '@ui/lib/utils.js';
import { cva, type VariantProps } from 'class-variance-authority';

export { default as PBadge } from './PBadge.vue';
export { default as PIconBadge } from './PIconBadge.vue';

export const pBadgeVariants = cva(
    cn(
        'inline-flex',
        'items-center',
        'justify-center',
        'rounded-lg',
        'border',
        'px-2',
        'py-0.5',
        'paragraph-xs',
        'font-bold',
        'w-fit',
        'whitespace-nowrap',
        'shrink-0',
        '[&>svg]:size-3',
        'gap-1',
        '[&>svg]:pointer-events-none',
        'outline-none',
        'focus-visible:ring-ring-default',
        'focus-visible:ring-[3px]',
        'aria-invalid:ring-ring-error',
        'aria-invalid:border-surface-destructive',
        'transition-[color,box-shadow]',
        'overflow-hidden',
    ),
    {
        variants: {
            variant: {
                default:
                    'border-transparent bg-surface-primary text-foreground-on-primary [a&]:hover:bg-surface-primary/90',
                secondary:
                    'border-transparent bg-surface-secondary text-foreground-on-secondary [a&]:hover:bg-surface-secondary/90',
                outline:
                    'text-foreground-primary border-border-default bg-surface-background [a&]:hover:bg-surface-background/90 ',
                ghost: 'border-transparent text-foreground-primary bg-surface-ghost [a&]:hover:bg-surface-ghost/90 ',
                destructive:
                    'border-transparent bg-surface-destructive text-foreground-on-primary [a&]:hover:bg-surface-destructive/90 focus-visible:ring-ring-error',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export const pIconBadgeVariants = cva('rounded-full ', {
    variants: {
        size: {
            default: '[&>svg]:size-4 p-0.5',
            small: '[&>svg]:size-2.5 size-4 p-0',
        },
    },
    defaultVariants: {
        size: 'default',
    },
});

export type PBadgeVariants = VariantProps<typeof pBadgeVariants>;
export type PIconBadgeVariants = VariantProps<typeof pIconBadgeVariants>;
